import ModelStore from 'stores/model/ModelStore'
import RecordStore from 'stores/record/RecordStore'
import ActionStore from 'stores/action/ActionStore'

import isFieldValueInvalid from 'utils/isFieldValueInvalid'
import createError from 'utils/createError'

const isActionValid = (actionId: string) => {
  const action = ActionStore.get(actionId)

  if (!action) {
    throw createError('isActionValid', 'Invalid action', {
      actionId,
    })
  }

  const record = RecordStore.get(action.recordId)
  if (!record) {
    return false
  }

  const model = record.model
  if (!model) {
    return false
  }

  const changedFieldNames = Object.keys(action.value)

  switch (action.type) {
    case 'create':
      return !!ModelStore.get(action.value.modelId)

    case 'delete':
      return !!RecordStore.get(action.recordId)

    case 'update':
      return changedFieldNames.every(fieldName => {
        const field = model.getFieldByName(fieldName)
        const value = action.value[fieldName]

        if (!field) {
          // If there's no such field, it is invalid. Should never happen
          return false
        }

        return !isFieldValueInvalid(field, value)
      })

    default:
      return false
  }
}

export default isActionValid
